import { guideSteps } from "@/mocks/home";

export default function AntiLossGuide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=a%20hand%20placing%20a%20warm%20paper%20bookmark%20into%20a%20notebook%20beside%20a%20celadon%20ceramic%20teacup%20on%20a%20clean%20cream%20desk%2C%20soft%20morning%20light%2C%20calm%20oriental%20lifestyle%20editorial%20photography&width=900&height=1200&seq=liuli-guide-bookmark-2026&orientation=portrait"
                alt="防走失收藏指引配图"
                title="琉璃神社防走失收藏方法"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.2em] text-primary-700 uppercase">Anti-lost Guide</p>
            <h4 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              <a href="#guide" className="cursor-pointer hover:text-primary-700 transition-colors">
                防走失指引 · 四步收藏法
              </a>
            </h4>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-2xl">
              域名会变，方法不变。按下面四步操作一次，以后就算原网址失效，也能顺着线索找回入口。
            </p>

            <ol className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {guideSteps.map((step) => (
                <li
                  key={step.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
                >
                  <span className="font-heading text-2xl text-accent-500">{step.index}</span>
                  <h5 className="mt-2 text-[15px] font-medium text-foreground-950">{step.title}</h5>
                  <p className="mt-2 text-[13px] text-foreground-600 leading-relaxed">{step.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}